/**
 * Icon re-exports using Lucide React
 * All icons are professional, consistent, and tree-shakeable
 */
import {
  LayoutDashboard,
  CarFront,
  Wrench,
  Settings as SettingsLucide,
  Package,
  Container,
  Users,
  MessageSquare,
  ClipboardCheck,
  ScanLine,
  Plus,
  SquarePen,
  Trash2,
  LogOut,
  Upload,
  Image,
  Search,
  Printer,
  Download,
  ChevronDown,
  ChevronRight,
  Check,
  X,
  BarChart3,
  DollarSign,
  Activity,
  PackageOpen,
  Filter,
  Calendar,
  Globe,
  Menu,
  Camera,
  Bell,
  Calculator,
  LayoutGrid,
  List,
} from 'lucide-react';

// Standard size for all icons (matches existing usage)
const S = { size: 18, strokeWidth: 1.5 };

// Dashboard
export const DashboardIcon = (props) => <LayoutDashboard {...S} {...props} />;

// Car/Vehicle
export const CarIcon = (props) => <CarFront {...S} {...props} />;

// Engine (custom — Lucide has no engine icon)
export const EngineIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M7 4v4" /><path d="M11 4v4" /><path d="M7 8h6a2 2 0 012 2v4a2 2 0 01-2 2H7a2 2 0 01-2-2v-4a2 2 0 012-2z" />
    <path d="M5 12H3" /><path d="M5 14H3" /><path d="M15 11h2l2 2v2h-2" /><path d="M7 16v4" /><path d="M11 16v4" />
  </svg>
);

// Parts/Gear
export const PartsIcon = (props) => <Wrench {...S} {...props} />;

// Container
export const ContainerIcon = (props) => <Container {...S} {...props} />;

// Inventory/Package
export const InventoryIcon = (props) => <Package {...S} {...props} />;

// Users
export const UsersIcon = (props) => <Users {...S} {...props} />;

// Request/Message
export const RequestIcon = (props) => <MessageSquare {...S} {...props} />;

// Settings
export const SettingsIcon = (props) => <SettingsLucide {...S} {...props} />;

// Stock/Clipboard
export const StockIcon = (props) => <ClipboardCheck {...S} {...props} />;

// Scan/QR
export const ScanIcon = (props) => <ScanLine {...S} {...props} />;

// Plus
export const PlusIcon = (props) => <Plus {...S} strokeWidth={2} {...props} />;

// Edit
export const EditIcon = (props) => <SquarePen {...S} {...props} />;

// Delete/Trash
export const DeleteIcon = (props) => <Trash2 {...S} {...props} />;

// Logout
export const LogoutIcon = (props) => <LogOut {...S} {...props} />;

// Upload
export const UploadIcon = (props) => <Upload {...S} {...props} />;

// Image
export const ImageIcon = (props) => <Image {...S} {...props} />;

// Search
export const SearchIcon = (props) => <Search {...S} {...props} />;

// Print
export const PrintIcon = (props) => <Printer {...S} {...props} />;

// Download
export const DownloadIcon = (props) => <Download {...S} {...props} />;

// ChevronDown
export const ChevronDownIcon = (props) => <ChevronDown {...S} strokeWidth={2} {...props} />;

// ChevronRight
export const ChevronRightIcon = (props) => <ChevronRight {...S} strokeWidth={2} {...props} />;

// Check
export const CheckIcon = (props) => <Check {...S} strokeWidth={2} {...props} />;

// X/Close
export const XIcon = (props) => <X {...S} strokeWidth={2} {...props} />;

// WhatsApp (Lucide doesn't have brand icons — keep custom SVG)
export const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

// BarChart
export const BarChartIcon = (props) => <BarChart3 {...S} {...props} />;

// DollarSign
export const DollarSignIcon = (props) => <DollarSign {...S} {...props} />;

// Activity
export const ActivityIcon = (props) => <Activity {...S} {...props} />;

// Package
export const PackageIcon = (props) => <PackageOpen {...S} {...props} />;

// Filter
export const FilterIcon = (props) => <Filter {...S} {...props} />;

// Calendar
export const CalendarIcon = (props) => <Calendar {...S} {...props} />;

// Globe
export const GlobeIcon = (props) => <Globe {...S} {...props} />;

// Menu
export const MenuIcon = (props) => <Menu {...S} {...props} />;

// Camera
export const CameraIcon = (props) => <Camera {...S} {...props} />;

// Bell
export const BellIcon = (props) => <Bell {...S} {...props} />;

// Calculator
export const CalculatorIcon = (props) => <Calculator {...S} {...props} />;

// Grid view
export const GridIcon = (props) => <LayoutGrid {...S} {...props} />;

// List view
export const ListIcon = (props) => <List {...S} {...props} />;

// Export all icons as object
export const Icons = {
  Dashboard: DashboardIcon,
  Car: CarIcon,
  Engine: EngineIcon,
  Parts: PartsIcon,
  Container: ContainerIcon,
  Inventory: InventoryIcon,
  Users: UsersIcon,
  Request: RequestIcon,
  Settings: SettingsIcon,
  Stock: StockIcon,
  Scan: ScanIcon,
  Plus: PlusIcon,
  Edit: EditIcon,
  Delete: DeleteIcon,
  Logout: LogoutIcon,
  Upload: UploadIcon,
  Image: ImageIcon,
  Search: SearchIcon,
  Print: PrintIcon,
  Download: DownloadIcon,
  ChevronDown: ChevronDownIcon,
  ChevronRight: ChevronRightIcon,
  Check: CheckIcon,
  X: XIcon,
  WhatsApp: WhatsAppIcon,
  BarChart: BarChartIcon,
  DollarSign: DollarSignIcon,
  Activity: ActivityIcon,
  Package: PackageIcon,
  Filter: FilterIcon,
  Calendar: CalendarIcon,
  Globe: GlobeIcon,
  Menu: MenuIcon,
};

export default Icons;
